import { downgradeComponent } from '@angular/upgrade/static';
import { HeaderComponent } from '../../../../../../app/shared/header/header.component';
declare var angular: any;

angular
  .module('GlobalControllers')

  .directive(
    'polylearnHeader',
    downgradeComponent({ component: HeaderComponent })
  )

  .controller('NotToolbarCtrl', [
    '$scope',
    '$mdSidenav',
    '$location',
    'exam',
    'EXAM',
    function($scope, $mdSidenav, $location, exam, EXAM) {
      console.log('yolo', exam.examData);

      $scope.exam = exam;
      $scope.links = [
        /*
      {
        text: 'Aide',
        link: '#'
      },
      {
        text: 'Offres',
        link: 'nos-offres'
      },
      */
        {
          text: 'Activation',
          link: 'activation',
          show: $scope.exam.examData.login.canActivate
        },
        {
          text: 'Inscription',
          link: 'register',
          show: $scope.exam.examData.login.canRegister
        },
        {
          text: 'Connexion',
          link: 'login',
          show: true
        }
      ].filter(function(link) {
        return !!link.show;
      });

      $scope.isIndex = false;
      $scope.$watch(
        function() {
          return $location.path();
        },
        function(value) {
          $scope.url = value;
          if (value === '/') {
            $scope.isIndex = true;
          } else {
            $scope.isIndex = false;
          }
          console.log(value);
        }
      );

      $scope.openMenu = function() {
        $mdSidenav('navbar').toggle();
      };
    }
  ])

  .controller('UserToolbarCtrl', [
    '$scope',
    'secondNavbar',
    function($scope, secondNavbar) {
      $scope.tabs = secondNavbar.tabs;
    }
  ]);
